import React, { useState, useEffect } from "react";
import { Button, message } from "antd";
import { platformApi } from "../../../../api";
import PromotionTable from "./PromotionTable/index";

const Index = (props) => {
  const [data, setData] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [syncing, setSyncing] = useState(false);

  const fetchPromoTemplates = () => {
    setSpinning(true);
    platformApi
      .get("/api/whatsapp/promoWhatsapp")
      .then((res) => {
        setSpinning(false);
        const { data: resData } = res;
        if (resData.code === 200) {
          const templateData = (resData.msg && resData.msg.data) || [];
          setData(
            (templateData || []).filter((item) => item && item.name)
          );
        } else {
          message.error("Unable to fetch templates", 2);
        }
      })
      .catch(() => {
        setSpinning(false);
        message.error("Unable to fetch templates", 2);
      });
  };

  useEffect(() => {
    fetchPromoTemplates();
  }, []);

  const syncPromoTemplates = () => {
    setSyncing(true);
    platformApi
      .get("/api/whatsapp/syncPromoTemplates")
      .then((res) => {
        setSyncing(false);
        if (res.data.code === 200) {
          const inserted =
            res.data.response && res.data.response.inserted != null
              ? res.data.response.inserted
              : 0;
          const updated =
            res.data.response && res.data.response.updated != null
              ? res.data.response.updated
              : 0;
          message.success(
            `Marketing templates synced (new: ${inserted}, updated: ${updated})`,
            3
          );
          fetchPromoTemplates();
        } else {
          message.error("Unable to sync marketing templates", 2);
        }
      })
      .catch(() => {
        setSyncing(false);
        message.error("Unable to sync marketing templates", 2);
      });
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "16px",
        }}
      >
        <Button type="primary" onClick={syncPromoTemplates} loading={syncing}>
          Sync
        </Button>
      </div>
      <PromotionTable
        dataSource={data}
        loading={spinning || props.spinning}
        pagination={props.pagination}
      />
    </div>
  );
};

export default Index;
